//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useContext, useCallback, useEffect, Fragment } from "react";
import * as moment from 'moment';

// custom pages
import 'assets/css/header.css';
import { useLocation, Route, Redirect } from 'react-router-dom';
import Context from 'context/context';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';

import Grid from '@material-ui/core/Grid';

// routes
import DashboardRoutes from 'routes/DashboardRoutes/dashboardRoutes';
import SideBarRoutes from 'routes/SideBarRoutes/sideBarRoutes';
import FilterRoutes from 'routes/FilterRoutes';


// Material Ui
import Popover from '@material-ui/core/Popover';
import { headerStyles } from './style';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { withStyles } from '@material-ui/styles';
import { Link } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import LanguageSharpIcon from '@material-ui/icons/LanguageSharp';
import { useTranslation } from 'react-i18next';
import { imageHandler } from 'helpers/imageHandler';
import {urlHandler} from 'helpers/urlHandler';


const GlobalCss = withStyles({
  '@global': {
    '.MuiList-padding': {
      padding: '0px',
    },
  },
})(() => null);

export default function DashboardHeader() {
  const { state, dispatch } = useContext(Context);
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [isAdminOption, setIsAdminOption] = useState(false);
  const [isITAdminOption, setIsITAdminOption] = useState(false);

  const classes = headerStyles();

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const [states, setstates] = useState({
    CustomDashboard: [],
    sidebar: [],
  });

  useEffect(() => {
    if (state && state.userInfo && Object.keys(state.userInfo).length > 0) {
      handleSetDashboard();
      return;
    }
  }, [state.userInfo]);

  // mounting components
  async function handleSetDashboard() {
    try {
      if (
        state &&
        state.userInfo.allowedRoutes &&
        Object.keys(state.userInfo.allowedRoutes).length > 0
      ) {
        const customDashboard = DashboardRoutes.map((route, i) => {
          if (route.redirect) {
            return <Redirect key={`DashBoardRoutes-${i}`} to={route.to} />;
          }
          return (
            <Route
              key={i}
              path={route.path}
              component={() => <route.component key={i} />}
            />
          );
        });
        const filteredDashboardRoutes = FilterRoutes(
          customDashboard,
          state.userInfo.allowedRoutes
        );
        const filteredSideBarRoutes = FilterRoutes(
          SideBarRoutes,
          state.userInfo.allowedRoutes
        );
        if (filteredDashboardRoutes && filteredSideBarRoutes) {
          setStates({
            CustomDashboard: filteredDashboardRoutes,
            sidebar: filteredSideBarRoutes,
          });
        }
      }
    } catch (e) {
      console.log({ e });
    }
  }

  // const [states, setstates] = useState({
  //   loyalityAccount: {},
  // });

  // const setStates = useCallback((newState) => {
  //   setstates((states) => ({ ...states, ...newState }));
  // }, []);

  const toggleAdminOption = () => {
    setIsAdminOption(!isAdminOption);
  };
  const toggleAdminOptionIT = () => {
    setIsITAdminOption(!isITAdminOption);
  };

  // specified routes
  

  const routes1 =states?.sidebar?.filter((item) => !item.isAdmin && !item.isITAdmin);
  const isCanada = state.userInfo?.loyalty_organization_name === "Henry Schein Canada";
  const isUS     = state.userInfo?.loyalty_organization_name === "Henry Schein Dental";
  const routes2 = states?.sidebar?.filter(item => {
    
    // Canada → Tier Range only in Admin
    if (item.name === "Tier Range" && isCanada) {
      return true;  // include in Admin
    }
    
    // US → Tier Range NOT in Admin
    if (item.name === "Tier Range" && isUS) {
      return false; // exclude from Admin
    }
  
    return item.isAdmin && !item.isITAdmin;
  });
  
  // IT ADMIN ROUTES
  const routes3 = states?.sidebar?.filter(item => {
  
    // US → Tier Range only in IT Admin
    if (item.name === "Tier Range" && isUS) {
      return true;  // include in IT Admin
    }
  
    // Canada → Tier Range NOT in IT Admin
    if (item.name === "Tier Range" && isCanada) {
      return false; // exclude from IT Admin
    }
  
    return item.isITAdmin;
  });
  // const routes2 = states?.sidebar?.filter((item) => item.isAdmin && !item.isITAdmin);
  // const routes3 = states?.sidebar?.filter((item) => item.isITAdmin);

  const org = state?.userInfo?.loyalty_organization_name;
  const tier = state?.ALA?.["Loyalty_Account.tier"];

  // check current route
  function isThisRoute(sidebar) {
    if (sidebar) {
      if (
        sidebar.to.toLowerCase() === window.location.pathname.toLowerCase() ||
        sidebar.childRoutes.includes(window.location.pathname.toLowerCase())
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      let isCurrentPath = false;
      routes2.forEach((item) => {
        if (
          item.to.toLowerCase() === window.location.pathname.toLowerCase() ||
          item.childRoutes.includes(window.location.pathname.toLowerCase())
        ) {
          isCurrentPath = true;
        }
      });
      return isCurrentPath;
    }
  }

  const redirectLink = (link, redirect) => {
    if (redirect) {
      return;
    }
    return link;
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
 
  
  return (
    <React.Fragment>
      <GlobalCss />
      <Grid container className={classes.gridContainer}>
        <Grid item sm={10} className={classes.flexGrid}>
          <div className={classes.logoImgDiv}>
            <img
              src={
                org == "Henry Schein Canada" ? 
                imageHandler?.[org]?.[i18n?.language]?.[`${tier}HeaderLogo`] : 
                "https://www.thriverewards.henryschein.com:8080/web/v1/static/images/logo.png"
              }
              className={classes.logoImg}
            />
          </div>
        </Grid>

        <div className={classes.flexBoxDiv}>
          <Grid item sm={1} className={classes.grid}>
            <IconButton className={classes.menuIconBtn} onClick={handleClick}>
              <MenuIcon className={classes.menuIcon} />
            </IconButton>{' '}
            <br />
            <div onClick={handleClick} className={classes.ref}>
              {t('Menu')}
            </div>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              style={{ opacity: 0.8 }}
            >
              <List>
                {routes1 &&
                  routes1.map((route, i) => (
                    <Fragment key={i}>
                      {route.to === "/dashboard/redeem" ? (
                        (state?.ALA?.["Loyalty_Account.is_active"] 
                        // &&
                          // !(state?.userInfo?.role_id == null &&
                          //   (state?.ALA?.["Loyalty_Account.tier"] == "Bronze" && sessionStorage.getItem('redeemBtnDisabled') != null))
                            ) && 
                            (
                          <Link
                            key={t(route.name)}
                            to={
                               redirectLink(route.to, route.isRedirect)
                            }
                            className={classes.Link}
                            onClick={() => {
                              handleClose();
                              if (route.isRedirect) {
                                i18n.language == "en" ? window.open(route.to) : window.open(route.to_fr);
                                return;
                              }
                              if (window.innerWidth < 600) {
                                dispatch({ type: 'SET_SIDEBAR', payload: false });
                                return;
                              }
                              document.body.scrollTop = 0; // For Safari
                              document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                            }}
                          >
                            <ListItem
                              button
                              style={
                                i === 0 ? { borderTop: "1px solid #e4e4e4" } : null
                              }
                              className={
                                isThisRoute(route)
                                  ? classes.sidebarItemActive
                                  : classes.listItem
                              }
                            >
                              <ListItemText className={classes.sideBarCustomTextSize}>
                                <span className={classes.sideBarStyle}>
                                  {t(route.name)}
                                </span>
                              </ListItemText>
                            </ListItem>
                            <hr className={classes.hrTag} />
                          </Link>
                        )
                      ) : route.to === "/dashboard/statements" ? 
                      ((moment(state?.ALA?.["Loyalty_Account.created_at"]).format('YYYY') != moment().format('YYYY') 
                      && ((!state?.ALA?.["Loyalty_Account.dormant_paused_date"]) || 
                      (
                        // if dormant_paused_date exists -> check reactivation_date
                        moment(
                          state?.ALA?.["Loyalty_Account.reactivation_date"] 
                          ? state?.ALA?.["Loyalty_Account.reactivation_date"] 
                          : new Date() // fallback: current date
                        ).format("YYYY") != moment().format("YYYY")
                      )
                      )
                      && state?.pointsBalance?.pointsBalance >= 0) &&
                     
                        <Link
                          key={i}
                          to={redirectLink(route.to, route.isRedirect)
                          }
                          className={classes.Link}
                          onClick={() => {
                            if (route.isRedirect) {
                              i18n.language == "en" ? window.open(route.to) : window.open(route.to_fr);
                              return;
                            }
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                          }}
                        >
                          <ListItem
                            button
                            style={
                              i === 0 ? { borderTop: '1px solid #e4e4e4' } : null
                            }
                            className={
                              isThisRoute(route)
                                ? classes.sidebarItemActive
                                : classes.listItem
                            }
                          >
                            <ListItemText className={classes.listItemTxt}>
                              <span className={classes.sideBarStyle}>
                                {t(route.name)}
                              </span>
                            </ListItemText>
                          </ListItem>
                        </Link>) : (
                        <Link
                          key={i}
                          to={ redirectLink(route.to, route.isRedirect)
                          }
                          className={classes.Link}
                          onClick={() => {
                            handleClose();
                            if (route.isRedirect) {
                              i18n.language == "en" ? window.open(route.to) : window.open(route.to_fr);
                              return;
                            }
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                          }}
                        >
                          <ListItem
                            button
                            className={
                              isThisRoute(route)
                                ? classes.sidebarItemActive
                                : classes.listItem
                            }
                          >
                            <ListItemText className={classes.sideBarCustomTextSize}>
                              <span className={classes.sideBarStyle}>
                                {t(route.name)}
                              </span>
                            </ListItemText>
                          </ListItem>
                          <hr className={classes.hrTag} />
                        </Link>
                      )}
                    </Fragment>
                  ))}
  {routes2.length ? (
  <div
    key="admin-sideBar"
    className={classes.Link}
    onClick={toggleAdminOption}
  >
    <ListItem
      button
      className={
        isThisRoute()
          ? classes.sidebarItemActive
          : classes.adminSidebarList
      }
    >
      <ListItemText className={classes.sideBarCustomTextSize}>
        <span className={classes.sideBarStyle}>
          {t('Admin')}
        </span>
      </ListItemText>

      {isAdminOption ? (
        <ArrowDropUpIcon />
      ) : (
        <ArrowDropDownIcon />
      )}
    </ListItem>

    <hr className={classes.hrTag} />
  </div>
) : null}
                {isAdminOption &&
                  routes2 &&
                  routes2.map((route, i) => (
                    <Link
                      key={t(route.name)}
                      to={ redirectLink(route.to, route.isRedirect)
                      }
                      className={classes.Link}
                      onClick={() => {
                        handleClose();
                        if (route.isRedirect) {
                          window.open(route.to);
                          return;
                        }
                        if (window.innerWidth < 600) {
                          dispatch({ type: 'SET_SIDEBAR', payload: false });
                          return;
                        }
                      }}
                    >
                      <ListItem
                        button
                        className={
                          isThisRoute(route)
                            ? classes.sidebarItemActive
                            : classes.listItem
                        }
                      >
                        <ListItemText className={classes.sideBarCustomTextSize}>
                          <span className={classes.sideBarStyle}>
                            {t(route.name)}
                          </span>
                        </ListItemText>
                      </ListItem>
                      <hr className={classes.hrTag} />
                    </Link>
                  ))}
                   {state?.userInfo?.role_id == 10 ? (
  <>
                  {routes3.length ? (
                  <div
                    key={'admin-sideBar'}                   
                    className={classes.Link}
                    onClick={toggleAdminOptionIT}
                  >
                    <ListItem
                      button
                      className={
                        isThisRoute()
                          ? classes.sidebarItemActive
                          : classes.adminSidebarList
                      }
                    >
                      <ListItemText className={classes.sideBarCustomTextSize}>
                        <span className={classes.sideBarStyle}>
                          {t('IT Admin')}
                        </span>
                      </ListItemText>
                      {isITAdminOption ? (
                        <ArrowDropUpIcon />
                      ) : (
                        <ArrowDropDownIcon />
                      )}
                    </ListItem>
                    <hr className={classes.hrTag} />
                  </div>
                ) : null}
                {isITAdminOption &&
                  routes3 &&
                  routes3.map((route, i) => (
                    <Link
                      key={t(route.name)}
                      to={redirectLink(route.to, route.isRedirect)
                      }
                      className={classes.Link}
                      onClick={() => {
                        handleClose();
                        if (route.isRedirect) {
                          window.open(route.to);
                          return;
                        }
                        if (window.innerWidth < 600) {
                          dispatch({ type: 'SET_SIDEBAR', payload: false });
                          return;
                        }
                      }}
                    >
                      <ListItem
                        button
                        className={
                          isThisRoute(route)
                            ? classes.sidebarItemActive
                            : classes.listItem
                        }
                      >
                        <ListItemText className={classes.sideBarCustomTextSize}>
                          <span className={classes.sideBarStyle}>
                            {t(route.name)}
                          </span>
                        </ListItemText>
                      </ListItem>
                      <hr className={classes.hrTag} />
                    </Link>
                  ))}
                   </>
                ) : null}
              </List>
            </Popover>
          </Grid>
          <Grid item className={classes.backToGrid}>
            <IconButton
              className={classes.globeIconBtn}
              onClick={() => window.open(urlHandler?.[org]?.[i18n?.language]?.[`header_henryschein_website`])}
            >
              <LanguageSharpIcon className={classes.languageIcon} />
            </IconButton>
            <br />
            <div
              className={classes.backtoHendry}
              onClick={() => window.open(urlHandler?.[org]?.[i18n?.language]?.[`header_henryschein_website`])}
            >
              {t(org) || "Henry Schein Dental"}
            </div>
          </Grid>
        </div>
      </Grid>
    </React.Fragment>
  );
}
